export default
{
    "title": '',
    "endP":"活動已結束",
    "versionLowPlaceholder":"此app版本過低，暫不支持跳轉功能，請麻煩到app內查看",
    "versionPlaceholder":"此APP版本過低，無法參與活動。請到【我的設定】>【版本】 進行升級",
    "common":{
        errorText:"未知錯誤,請稍後重試;",
        errorMiss:"參數缺失,請稍後重試;",
        submit: "提交",
        defaultInput: "請輸入",
        cancel: "取消",
        confirm: "確認",
        loginTimeout: "未登錄或者登錄超時，請重新登錄",
        noData: "沒有資料",
        custom: "在線客服",
    },
    "route": {
        "login": '登陆',
        "dashboard": '首页',
        "introduction": '简述',
        "documentation": '文档',
        "permission": '权限测试页',
        "icons": '图标',
        "components": '组件',
        "componentIndex": '介绍',
        "tinymce": '富文本编辑器',
        "markdown": 'Markdown',
        "jsonEditor": 'JSON编辑器',
        "dndList": '列表拖拽',
        "splitPane": 'Splitpane',
        "avatarUpload": '头像上传',
        "dropzone": 'Dropzone',
        "sticky": 'Sticky',
        "countTo": 'CountTo',
        "componentMixin": '小组件',
        "backToTop": '返回顶部',
        "charts": '图表',
        "keyboardChart": '键盘图表',
        "lineChart": '折线图',
        "mixChart": '混合图表',
        "example": '综合实例',
        "Table": 'Table',
        "dynamicTable": '动态Table',
        "dragTable": '拖拽Table',
        "inlineEditTable": 'Table内编辑',
        "complexTable": '综合Table',
        "treeTable": '树形表格',
        "customTreeTable": '自定义树表',
        "tab": 'Tab',
        "form": '表单',
        "createForm": '创建表单',
        "editForm": '编辑表单',
        "errorPages": '错误页面',
        "page401": '401',
        "page404": '404',
        "errorLog": '错误日志',
        "excel": 'Excel',
        "exportExcel": 'Export Excel',
        "selectExcel": 'Export Selected',
        "uploadExcel": 'Upload Excel',
        "zip": 'Zip',
        "exportZip": 'Export Zip',
        "theme": '换肤',
        "clipboardDemo": 'Clipboard',
        "i18n": '国际化'
    },
    "navbar": {
        "logOut": '退出登录',
        "dashboard": '首页',
        "github": '项目地址',
        "screenfull": '全屏',
        "theme": '换肤'
    },
    "login": {
        "title": '系统登录',
        "logIn": '登录',
        "username": '账号',
        "password": '密码',
        "any": '随便填',
        "thirdparty": '第三方登录',
        "thirdpartyTips": '本地不能模拟，请结合自己业务进行模拟！！！'
    },
    "documentation": {
        "documentation": '文档',
        "github": 'Github 地址'
    },
    "permission": {
        "roles": '你的权限',
        "switchRoles": '切换权限'
    },
    "components": {
        "documentation": '文档',
        "tinymceTips": '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        "dropzoneTips": '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
        "stickyTips": '当页面滚动到预设的位置会吸附在顶部',
        "backToTopTips1": '页面滚动到指定位置会在右下角出现返回顶部按钮',
        "backToTopTips2": '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        "imageUploadTips": '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
    },
    "table": {
        "dynamicTips1": '固定表头, 按照表头顺序排序',
        "dynamicTips2": '不固定表头, 按照点击顺序排序',
        "dragTips1": '默认顺序',
        "dragTips2": '拖拽后顺序',
        "title": '标题',
        "importance": '重要性',
        "type": '类型',
        "remark": '点评',
        "search": '搜索',
        "add": '添加',
        "export": '导出',
        "reviewer": '审核人',
        "id": '序号',
        "date": '时间',
        "author": '作者',
        "readings": '阅读数',
        "status": '状态',
        "actions": '操作',
        "edit": '编辑',
        "publish": '发布',
        "draft": '草稿',
        "delete": '删除',
        "cancel": '取 消',
        "confirm": '确 定'
    },
    "errorLog": {
        "tips": '请点击右上角bug小图标',
        "description": '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        "documentation": '文档介绍'
    },
    "excel": {
        "export": '导出',
        "selectedExport": '导出已选择项',
        "placeholder": '请输入文件名(默认excel-list)'
    },
    "zip": {
        "export": '导出',
        "placeholder": '请输入文件名(默认file)'
    },
    "theme": {
        "change": '换肤',
        "documentation": '换肤文档',
        "tips": 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
    },
    "veritrans": {
        "orderNo": "訂單號",
        "cardNum": "銀行卡號",
        "cardholderName": "持卡人姓名",
        "inputCard": "請輸入銀行卡號",
        "inputCardholderName": "請輸入持卡人姓名",
        "supportType": "支援類型",
        "expiryDate": "有效日期",
        "csc": "安全碼CSC",
        "pay": "支付",
        "paySettle": "支付處理中",
        "payCancel": "支付取消中",
        "payFailed": "支付失敗",
        "succeed": "完成支付",
        "fail": "未能支付，請重新下單",
        "Cancelpay": "取消支付",
        "repay": "重新支付",
        "contactUs": "聯系客服"
    },
    "msgPush": {
        "tips": "溫馨提醒",
        "closePush": "關閉後，你可能會錯過我們的優惠活動等相關信息",
        "confirm": "確定",
        "cancel": "取消",
        "appPush": "app消息推送",
        "emailPush": "郵件推送",
        "loginFirst": "未登錄或登錄失效，如需繼續操作，請先登錄？"
    },
    //paygo--开始
    "title": "GlocalMe",
	"route.Home": "按流量計費",
	"route.rate": "國家或地區費率",
	"route.record": "歷史記錄",
	"common.nonedata": "暫無數據",
	"common.nonedataRate": "暫無費率信息",
	"common.more": "更多",
    "route.home.flowType" : "按流量計費",
	"route.home.rateTit": "當前計費地區",
	"route.home.timeUse": "計費時長",
	"route.home.DataUse": "累計流量",
	"route.home.MoneyUse": "計費金額",
	"route.home.history": "查看扣費記錄 >",
	"route.home.OtherRate": "其他國家或地區費率",
	"route.home.useMethod": "使用方法",
	"route.home.addMinutes": "提前充值",
	"route.home.arrived": "到達目的地開機使用",
	"route.home.useRule": "使用規則",
	"route.home.updateTips": "你尚未升級至放心GO服務",
	"route.home.updateBtn": "立即升級",
	"route.home.updateBtn2": "立即升級",
	"route.home.LaterUpdateBtn": "晚點升級",
	"route.home.updateService": "升級服務",
	"route.home.updateSuccess": "升級成功",
	"route.home.country": "国家/地區",
	"route.home.cost": "資費",
	"route.home.TopCost": "封頂",
	"route.home.Success" : "好",
	"route.home.where" : "獲取不到位置",
	"route.home.ReLogin":"您已成功升級為放心GO服務！若您賬戶下有定額套餐，現已轉為疊加包。請返回APP重新登錄以刷新服務。溫馨提醒您出行前保證餘額充足",
    "route.home.ReLoginBtn":"去登錄",
    "route.home.flowTypeDesc":"無套餐可用時按流量計費。費率：{rateCurrency} {rate}/MB。(按流量計費時會臨時凍結一部分餘額)",
    "route.home.flowTypeDescLimit":"無套餐可用時按流量計費。費率：{rateCurrency} {rate}/MB，上限收費：{amountCurrency} {amount}。(按流量計費時會臨時凍結一部分餘額)",
    errorCode: {
        '01282001': '登錄用戶名或密碼錯誤',
        '01282002': '登錄用戶已停用',
        '01282003': '登錄用戶名為空',
        '01282004': '登錄密碼為空',
        '01282501': '代理商不存在',
        '01282503': '代理商已停用',
        '00000008': '登錄客戶與accessToken不匹配',
    },
    "paygo.basePayFlagMsg.true":"開啟成功",
    "paygo.basePayFlagMsg.false":"關閉成功",
    "paygo.QueryFlowHistory.NullData":"暫無數據",
    //paygo---结束
}



// WEBPACK FOOTER //
// ./src/lang/tw.js